import React from "react";

import useGet from "../../hooks/useGet";
import Loading from "../Loading";
import { groupPostsByLetter } from "../../helpers/groupByLetter";
import Term from "./Term";

const apiUrl = "/wp-json/pan/v1/glossary";

const Glossary = () => {
  const [loading, response, error] = useGet(apiUrl);

  return (
    <div className="Glossary">
      {loading && <Loading label="Loading..." />}

      {response && !loading && (
        <ol className="Glossary-items">
          {Object.entries(groupPostsByLetter(response.data)).map(entry => (
            <li key={entry[0]} className="Glossary-item">
              <p className="f-h2 u-mb2 f-uppercase">{entry[0]}</p>
              {entry[1].map((result, i) => (
                <Term glossary key={i} term={result} />
              ))}
            </li>
          ))}
        </ol>
      )}

      {error && <p>{error.message}</p>}
    </div>
  );
};

export default Glossary;